/**
 * Created by Administrador on 24/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('economicActivityCtrl', economicActivityCtrl)
        .controller('newEconomicActivityCtrl', newEconomicActivityCtrl)
        .controller('editEconomicActivityCtrl', editEconomicActivityCtrl)
        .controller('settingsEconomicActivityCtrl', settingsEconomicActivityCtrl)
        .controller('deleteEconomicActivityController', deleteEconomicActivityController);

    economicActivityCtrl.$inject = ['economicActivities','linkService'];
    newEconomicActivityCtrl.$inject = ['economicActivityService','taxpayers','linkService'];
    editEconomicActivityCtrl.$inject = ['economicActivityService','economicActivity','taxpayers','linkService'];
    settingsEconomicActivityCtrl.$inject = ['operationEconomicActivityService','linkService','economicActivity',
        'operations','operationsNotInEconomicActivity','operationsByEconomicActivity'];
    deleteEconomicActivityController.$inject = ['economicActivityService', '$uibModalInstance', '$stateParams'];

    function economicActivityCtrl(economicActivities,linkService) {
        var vm = this;
        vm.linkService = linkService;
        vm.pages = [];
        vm.economicActivities = (economicActivities.data._embedded) ? economicActivities.data._embedded.economicActivities : [];
        vm.pages = economicActivities.data.page;
    }

    function newEconomicActivityCtrl(economicActivityService,taxpayers,linkService) {
        var vm = this;
        vm.isDisabled = false;
        vm.economicActivity = {};
        vm.taxpayers = taxpayers;

        vm.saveEconomicActivity = function(isValid, economicActivity){
            if(isValid){
                var saveForm = {
                    "taxpayerId": parseInt(linkService.getLinkId(economicActivity.taxpayer._links.self.href)),
                    "description": economicActivity.description
                }
                economicActivityService.saveEconomicActivity(saveForm);
            }
        }
    }

    function editEconomicActivityCtrl(economicActivityService,economicActivity,taxpayers,linkService) {
        var vm = this;
        vm.isDisabled = true;
        vm.taxpayers = taxpayers;
        vm.economicActivity = {
            'taxpayer': economicActivity.data._embedded.taxpayer,
            'description':  economicActivity.data.description,
            'id': linkService.getLinkId(economicActivity.data._links.self.href)
        }

        vm.saveEconomicActivity = function(isValid, economicActivity){
            if(isValid){
                var saveForm = {
                    "taxpayerId": parseInt(linkService.getLinkId(economicActivity.taxpayer._links.self.href)),
                    "description": economicActivity.description
                }
                economicActivityService.updateEconomicActivity(saveForm, economicActivity.id);
            }
        }
    }

    function deleteEconomicActivityController(economicActivityService, $uibModalInstance, $stateParams){
        var vm = this;

        vm.deleteEconomicActivity = function(){
            economicActivityService.deleteEconomicActivity($stateParams.id)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function settingsEconomicActivityCtrl(operationEconomicActivityService,linkService,economicActivity,operations,
                                          operationsNotInEconomicActivity,operationsByEconomicActivity){
        var vm = this;
        vm.economicActivity = economicActivity.data;
        vm.operations = operations;
        vm.operationEconomicActivities = [];

        for(var i=0; i<operations.length; i++) {
            var band = false;
            for(var j=0; j<operationsNotInEconomicActivity.length; j++){
                if(linkService.getLinkId(operations[i]._links.self.href) == operationsNotInEconomicActivity[j].operationId){
                    band = true;
                    break;
                }
            }
            if(!band){
                var associate = false;
                var operationEconomicActivityId = 0;
                for(var k=0; k<operationsByEconomicActivity.length; k++){
                    if(linkService.getLinkId(operations[i]._links.self.href) == operationsByEconomicActivity[k].operationId){
                        associate = true;
                        operationEconomicActivityId = linkService.getLinkId(operationsByEconomicActivity[k]._links.self.href);
                        break;
                    }

                }
                vm.operationEconomicActivities.push(
                    {
                        "operationEconomicActivityId": operationEconomicActivityId,
                        "economicActivityId": linkService.getLinkId(economicActivity.data._links.self.href),
                        "operationId": linkService.getLinkId(operations[i]._links.self.href),
                        "descriptionLang": operations[i].descriptionLang,
                        "associate": associate,
                        "associateOld": associate
                    }
                );
            }
        }

        vm.saveOperationEconomicActivity = function(isValid, operationEconomicActivity){
            if(isValid){
                if(operationEconomicActivity.associate){
                    operationEconomicActivityService.saveOperationEconomicActivity(operationEconomicActivity);
                }else{
                    operationEconomicActivityService.deleteOperationEconomicActivity(operationEconomicActivity.operationEconomicActivityId);
                }
            }
        }
    }

})();
